import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "dashboard-cms";


type dashboardDataType = {
    start_date: string;
    end_date: string;
}

export class DashboardCmsApi extends BaseAPI {

    static findAll(query: dashboardDataType): Promise<AxiosResponse> {
        return this.api.get(`${path}/all`, {
            params: query
        })
    }
    static report(query: dashboardDataType): Promise<AxiosResponse> {
        return this.api.get(`${path}/report`, {
            params: query,
            responseType: 'arraybuffer'
        })
    }

}